import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import MD5 from 'js-md5'
import {
  closeLogin,
  openHomePage,
  openAdminPage,
  openCaiwuPage,
  openSchoolAdminPage,
} from '../../store/modalsSlice'
import { loginRequest } from './loginApi'
import styles from './Login.module.css'
import { API_URL, APP_ID, APP_KEY_LOCAL } from '../../util/constants'
import { Base64 } from 'js-base64'
import { Button, Col, ConfigProvider, Form, Input, message, Row } from 'antd'
import logoNameIcon from '../../assert/logo_name_icon.png'
import loginIcon from './login_icon.png'
import { setCurrentMenuKey } from '../HomePage/HomePageSlice'
import Cookies from 'js-cookie'
export default function Login() {
  //   const count = useSelector(selectCount);
  const dispatch = useDispatch()
  const [messageApi, contextHolder] = message.useMessage()

  // const incrementValue = Number(incrementAmount) || 0;

  useEffect(() => {
    // 在这里执行你的组件挂载后的逻辑
    // 这里可以返回一个清理函数，它会在组件卸载前执行
    changeDifyStatus(false)
    return () => {
      // console.log('组件即将卸载');
    }
  }, []) // 空数组意味着这个 effect 只会在组件挂载时执行一次

  function changeDifyStatus(showStatus) {
    // iframe.style.display = "none";
    var difyButton = document.getElementById('dify-chatbot-bubble-button')
    if (difyButton) {
      if (showStatus) {
        difyButton.style.display = 'block'
      } else {
        difyButton.style.display = 'none'
      }
    } else {
      setTimeout(() => {
        changeDifyStatus(showStatus)
      }, 500)
    }
  }
  const onFinish = async (values) => {
    loginRequest(values.username, values.password, (data) => {
      if (data.ret == 1) {
        //type=99 是超级管理员   1是普通账号

        //扣子space_id
        window.difyChatbotConfig = {
          token: 'oD5RsqcMFiDgEE6W',
          baseUrl: 'https://5e93.ygbh.run',
          systemVariables: {
            user_id: data.data.user_login,
          },
        }
        let result = data.data
        if (result.type == 2) {
          dispatch(setCurrentMenuKey('6'))
        } else {
          dispatch(setCurrentMenuKey('1'))
          changeDifyStatus(true)
        }
        for (let key in result) {
          if (result.hasOwnProperty(key)) {
            // 确保是对象自有属性，不是原型链上的属性
            // if(key!="username"&&key!="utoken"&&key!="pwd"&&key!="username_login"){
            if (key != 'pwd') {
              Cookies.set(key, result[key], { path: '/' })
            }
            let cookieList = ['user_login', 'name', "userToken",'username','type','school_code','image_url']
            if (cookieList.findIndex((item) => item == key) != -1) {
              Cookies.set(key, result[key], { path: '/' })
            }
          }
        }
        // type类型：99，管理员，2：学校管理员，1大管理分的账号，3：学校账号分的账号
        if (data.data.type == '99') {
          // dispatch(openUserInfo());
          dispatch(openAdminPage())
          dispatch(closeLogin())
        } else if (data.data.type == '1' || data.data.type == '3') {
          dispatch(openHomePage())
          dispatch(closeLogin())
        } else if (data.data.type == '2') {
          dispatch(openSchoolAdminPage())
          dispatch(closeLogin())
        } else if (data.data.type == '98') {
          dispatch(openCaiwuPage())
          dispatch(closeLogin())
        }
      } else {
        messageApi.error(data.msg, 1)
      }
    })
    return
    let token = ''
    const timestamp = new Date().getTime()
    // 获取当前的10位时间戳（秒）
    // var timestamp = Math.floor(Date.now() / 1000);
    // let tokenStr = timestamp + "," + loginUserName + "," + APP_ID + "," + MD5(timestamp + loginUserName + APP_KEY_LOCAL)
    // token = Base64.encode(tokenStr).toString();

    // loginRequest(loginUserName, password, token, (data) => {
    // })
    // onUpdate(true);

    return
  }

  function keyPress(e) {
    if (e.which === 13) {
      // loginMethod()
    }
  }

  return (
    <div
      className={styles.background}
      //  onKeyDown={keyPress}
    >
      {contextHolder}
      <div className={styles.leftContainer}>
        <div className={styles.leftBck}>
          <img src={logoNameIcon} className={styles.logoNameIcon}></img>
          <img src={loginIcon} className={styles.loginIcon}></img>
        </div>
      </div>
      <div className={styles.rightContainer}>
        <div style={{height:'100%',width:'100%',justifyContent:'center',alignItems:'center',display:'flex'}}>
          <div className={styles.rightFormContainer}>
            <div className={styles.rightTitle}>登录</div>
            <Form name="login" onFinish={onFinish}>
              <Form.Item
                name="username"
                rules={[{ required: true, message: '请输入用户名！' }]}
                style={{ marginBottom: 0 }}
              >
                <div className={styles.userName}>
                  <div className={styles.userNameDes}>用户名</div>
                  <input className={styles.userNameInput} />
                </div>
              </Form.Item>
              <Form.Item
                name="password"
                rules={[{ required: true, message: '请输入密码！' }]}
              >
                <div className={styles.password}>
                  <div className={styles.passwordDes}>密码</div>
                  <input className={styles.userNameInput} type="password" />
                </div>
              </Form.Item>
              <Form.Item style={{ width: 'calc(80% + 2px)' }}>
                <ConfigProvider
                  theme={{
                    token: {
                      colorPrimary: '#2772F0',
                    },
                  }}
                >
                  <Button
                    style={{
                      borderRadius: '20px',
                      maxHeight: '60px',
                      height: '10vh',
                      marginLeft: 10,
                    }}
                    type="primary"
                    htmlType="submit"
                    block
                  >
                    登录
                  </Button>
                </ConfigProvider>
              </Form.Item>
            </Form>
          </div>
        </div>
      </div>
    </div>
  )
}
